import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';
import PasswordInput from '../components/PasswordInput';
import './Auth.css';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async event => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await api.post('/auth/user/login', form);
      login(response.data.token, response.data.user);
      navigate('/portal');
    } catch (err) {
      setError(err.response?.data?.message || 'Could not sign in.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <section className="auth-story">
        <Link className="auth-back" to="/">&larr; Back to Royal Tower</Link>
        <div className="auth-story-copy">
          <span className="auth-kicker">Student &amp; staff portal</span>
          <h1>Your Royal Tower information, in one private place.</h1>
          <p>View your own profile, payments or salary, attendance and problem reports. Other residents' and staff members' information stays private.</p>
          <div className="auth-benefits">
            <span>Personal records only</span><span>Fee and salary status</span><span>Problem reporting</span>
          </div>
        </div>
      </section>
      <main className="auth-panel">
        <div className="auth-card">
          <div className="auth-brand"><Logo size={54} /><div><strong>Royal Tower</strong><span>User portal</span></div></div>
          <div className="auth-heading"><h2>Welcome back</h2><p>Students and staff use the username issued by the administration.</p></div>
          {error && <div className="auth-error">{error}</div>}
          <form className="auth-form" onSubmit={handleSubmit}>
            <label>Username<input autoComplete="username" value={form.username} onChange={event => setForm({ ...form, username: event.target.value })} required autoFocus /></label>
            <label>Password<PasswordInput autoComplete="current-password" value={form.password} onChange={event => setForm({ ...form, password: event.target.value })} required /></label>
            <button type="submit" disabled={loading}>{loading ? 'Signing in...' : 'Sign in to my portal'}</button>
          </form>
          <p className="auth-help">Need an account or password reset? Contact the hostel administration.</p>
        </div>
      </main>
    </div>
  );
}
